import React from 'react';
import types from 'prop-types';

// Styles

import './styles.scss';

// ----------------

// Type of props

PageWrapper.propTypes = {
  className: types.string,
  children: types.node,
  style: types.object
};

// Default value for props

PageWrapper.defaultProps = {
  className: ''
};

// ----------------

export default function PageWrapper(props) {
  const { className, style, children } = props;

  return (
    <div className={`page-wrapper  ${className}`} style={style}>
      {children}
    </div>
  );
}
